import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { eur } from "../sampling/common";

export function LabsSummary() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/productions/labs").then(r => setRows(r.data)).catch(() => setRows([])); }, []);
  if (!rows) return <div className="text-sm opacity-60">Caricamento…</div>;
  if (!rows.length) return <div className="text-sm opacity-60 p-10 border border-dashed text-center" data-testid="labs-empty">Nessun laboratorio assegnato. Apri una produzione e scegli il laboratorio (fornitori di categoria "Produzione/Confezione").</div>;
  return (
    <div className="card-dark overflow-x-auto"><table className="tbl w-full" data-testid="labs-table">
      <thead><tr><th>Laboratorio</th><th className="!text-right">In corso</th><th className="!text-right">Completate</th><th className="!text-right">Pezzi</th><th className="!text-right">Giorni medi</th><th className="!text-right">In ritardo</th><th className="!text-right">Costo totale</th></tr></thead>
      <tbody>{rows.map(r => (
        <tr key={r.supplier_id || r.name} data-testid={`labs-row-${r.supplier_id || r.name}`}>
          <td className="font-medium">{r.name}</td><td className="text-right">{r.active}</td><td className="text-right">{r.completed}</td>
          <td className="text-right">{r.pieces}</td><td className="text-right">{r.avg_lead_days ?? "—"}</td>
          <td className={`text-right ${r.late ? "text-red-600" : ""}`}>{r.late}</td><td className="text-right">{eur(r.total_cost)}</td>
        </tr>))}</tbody>
    </table></div>
  );
}
